// v2.0.0 after updating this file you need to re-run webpack with changed worker-loader options filename 1) and then return to 2)

const markUpUrl = "/api/markup/get-features/";

const _fetchRequest = (fetchUrl, method = 'GET', postData) => {
  return fetch(fetchUrl, {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(postData),
  })
}

self.addEventListener('message', async (e) => {
  const { type, payload } = e.data;

  if (type === 'fwFetchFeatureGroups') {

    const page = payload.page || 0;
    const totalGroupsCount = payload.toRequestFeatureGroups.length;
    let requestsCompleted = 0;

    payload.toRequestFeatureGroups.forEach(fgObject => {
      (async () => {
        const fetchUrl = fgObject.fetchGroupUrl;

        // 1) Notify request started
        self.postMessage({type: 'fwRequestGroup', data: { groupName: fgObject.groupName, fetchUrl, page }});

        try {
          const response = await _fetchRequest(fetchUrl);
          const dbFeatures = await response.json();

          let dataToReturn = {
            groupName: fgObject.groupName,
            fetchUrl,
            dbFeatures,
            page,
          };

          if (payload.withMarkUp) {
            const arrayOfIds = dbFeatures.map(dbFeature => dbFeature.id);
            const markUpResponse = await _fetchRequest(fgObject.baseUrl + markUpUrl,"POST",arrayOfIds);
            dataToReturn.markUpResponse = await markUpResponse.json();
          }

          // 2) Notify data ready
          self.postMessage({ type: 'fwUpdateCache', data: dataToReturn });

        } catch (error) {
          console.error(`Error fetching group ${fgObject.groupName}:`, error);
          self.postMessage({type: 'fwGroupError', data: {groupName: fgObject.groupName, fetchUrl, error: error.message }});
        } finally {
          requestsCompleted++;
          if (requestsCompleted === totalGroupsCount) {
            self.postMessage({type: 'fwGroupsAllRequested', data: {}});
          }
        }
      })();
    });
  }
});
